/* eslint-disable quote-props */
import { I18n } from 'aws-amplify';

export const dict = {
  'zh': {
    'Account recovery requires verified contact information': '恢復帳戶需要驗證聯繫方式',
    'Back to Sign In': '回到登入',
    'Change Password': '改變密碼',
    Changing: '變更中',
    Code: '驗證碼',
    Confirm: '確認',
    'Confirm Password': '確認密碼',
    'Please confirm your Password': '確認密碼',
    'Confirm SMS Code': 'Confirm SMS Code',
    'Confirm Sign In': '確認登入',
    'Confirm Sign Up': '確認註冊',
    'Confirm TOTP Code': 'Confirm TOTP Code',
    'Confirm a Code': '驗證碼',
    'Confirmation Code': '驗證碼',
    Confirming: '確認中',
    'Create Account': '創建帳戶',
    'Create a new account': '創建帳戶',
    'Create account': '創建帳戶',
    Email: '電子信箱',
    'Enter your code': '輸入驗證碼',
    'Enter your email': '輸入電子信箱',
    'Enter your phone number': '輸入電話號碼',
    'Enter your username': '輸入帳號',
    'Enter your Username': '輸入帳號',
    'Enter your Password': '輸入密碼',
    'Forgot Password': '忘記密碼',
    'Forgot your password?': '忘記密碼',
    'Hide password': '隱藏密碼',
    'Incorrect username or password': '帳號或密碼錯誤',
    'Invalid password format': '密碼格式錯誤',
    'Invalid phone number format': '電話格式錯誤，請使用格式 +12345678900',
    'Invalid email address format.': '電子信箱格式錯誤',
    Loading: '載入中',
    Name: '姓名',
    'Enter your Name': '姓名',
    'New Password': '新密碼',
    'New password': '新密碼',
    Password: '密碼',
    'Phone': '電話',
    'Phone Number': '電話',
    'Enter your Phone Number': '電話',
    'Resend Code': '重新發送驗證碼',
    'Resend a Code': '重新發送驗證碼',
    'Reset your Password': '重設密碼',
    'Reset your password': '重設密碼',
    'Reset Password': '重設密碼',
    'Send Code': '發送驗證碼',
    'Send code': '發送驗證碼',
    Sending: '發送中',
    'Setup TOTP': 'Setup TOTP',
    'Show password': '顯示密碼',
    'Sign In': '登入',
    'Sign In with Amazon': 'Sign In with Amazon',
    'Sign In with Apple': 'Sign In with Apple',
    'Sign In with Facebook': 'Sign In with Facebook',
    'Sign In with Google': 'Sign In with Google',
    'Sign Out': '退出',
    'Sign Up': '註冊',
    'Sign in': '登入',
    'Sign in to your account': 'Sign in to your account',
    'Signing in': '登入中',
    Skip: '跳過',
    Submit: '送出',
    Submitting: '送出中',
    'User already exists': '帳號已經存在',
    'User does not exist': '帳號不存在',
    Username: '帳號/電子信箱',
    Verify: '驗證',
    'Verify Contact': '驗證聯繫方式',
    or: '或者',
    TypeError: '格式錯誤',
    'We Emailed You': '驗證電子信箱',
    'We Sent A Code': '驗證電子信箱',
    'We Texted You': '驗證電子信箱',
    'Your code is on the way. To log in, enter the code we sent you.': '請查看您的電子信箱，驗證碼需數分鐘才會寄達。',
    'Your code is on the way. To log in, enter the code we sent you': '請查看您的電子信箱',
    'Your passwords must match': '密碼不同',
    'Password must have at least 8 characters': '至少8碼',
    'Creating Account': '帳戶創建中',
    'User does not exist.': '用戶不存在',
    'Your code is on the way. To log in, enter the code we emailed to': '驗證碼已寄送至信箱',
    'It may take a minute to arrive.': '(數分鐘內將寄達)',
    'It may take a minute to arrive': '(數分鐘內將寄達)',
    'Invalid verification code provided, please try again.': '驗證碼錯誤，請重試',
    'Password cannot be empty': '密碼不能為空白',
    'Incorrect username or password.': '帳號或密碼錯誤',
  },
};

I18n.putVocabularies(dict);

I18n.setLanguage('zh-Hant');
